'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FieldGroup = require('./FieldGroup');

var _FieldGroup2 = _interopRequireDefault(_FieldGroup);

var _FieldEdit = require('./FieldEdit');

var _FieldEdit2 = _interopRequireDefault(_FieldEdit);

var _FieldView = require('./FieldView');

var _FieldView2 = _interopRequireDefault(_FieldView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// Using this for a typical horizontal editable field. Mostly a passthrough. Field form container.
function FieldWrapper(_ref) {
  var isActive = _ref.isActive,
      isEditable = _ref.isEditable,
      showEdit = _ref.showEdit,
      showPreview = _ref.showPreview,
      field = _objectWithoutProperties(_ref, ['isActive', 'isEditable', 'showEdit', 'showPreview']);

  return _react2.default.createElement(
    _FieldGroup2.default,
    _extends({}, field, { isActive: isActive }),
    showEdit && _react2.default.createElement(_FieldEdit2.default, _extends({}, field, { className: 'editable-parent' })),
    showPreview && _react2.default.createElement(_FieldView2.default, _extends({}, field, { isActive: isActive, isEditable: isEditable }))
  );
}

FieldWrapper.propTypes = {
  isActive: _propTypes2.default.bool.isRequired,
  isEditable: _propTypes2.default.bool.isRequired,
  showEdit: _propTypes2.default.bool.isRequired,
  showPreview: _propTypes2.default.bool.isRequired
};

FieldWrapper.defaultProps = {};
exports.default = FieldWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/Editable/FieldEl.js
// module id = 674
// module chunks = 0